import { SMap } from '@avantia/client-and-server-utilities';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  HpTransferToCustomerPortalPayload,
  transferToCustomerPortalAction
} from '../actions/transferToCustomerPortalAction';
import { gtmTags } from '../config/configureGtm';
import { triggerPageLoadEvent } from '../engineClient/actions/eventActions';
import { BasicHeadingControl } from '../engineClient/components/headings/basicHeadingControl';
import { registerConfigurationAction } from '../engineClient/config/registerClientConfig';
import { setCookie } from '../engineClient/tools/clientCookies';
import { HpClientAnswer, HpDispatchFunction } from '../engineClient/types';
import { HpClaimEnquiryResultState, HpGlobalState } from '../types/stateTypes';
import { DetailsWidget } from './widgets/detailsWidget';
export type ClaimConfirmationPageProps = HpStateProps & ClaimEnquiryResultDispatchProps & RouteComponentProps;

interface HpStateProps extends HpClaimEnquiryResultState {
  answers: SMap<HpClientAnswer>;
}

let answersKey: string;
registerConfigurationAction((config) => {
  ({ answersKey } = config);
});

type pageTitleType = 'Claim submitted' | 'Save incident';

class ClaimEnquiryResultPage extends React.Component<ClaimConfirmationPageProps> {
  componentDidMount(): void {
    const { submissionType } = this.props;
    let gtmTag: string;
    let pageTitle: pageTitleType;
    if (submissionType === 'claim') {
      gtmTag = gtmTags.confirmationPage;
      pageTitle = 'Claim submitted';
    } else {
      gtmTag = gtmTags.saveClaimPage;
      pageTitle = 'Save incident';
    }

    triggerPageLoadEvent({ hash: null, gtmTag, path: location.pathname, title: pageTitle });
    setCookie({ name: answersKey, value: '' });
  }

  public render(): JSX.Element {
    const {
      heading,
      subHeading,
      claimReferenceText,
      whatsNextItems,
      saveClaimText,
      submissionType,
      claimReferenceNumber,
      transferToCustomerPortal,
      answers
    } = this.props;
    if (!claimReferenceNumber) {
      // TODO AL - Load qset and answers if falls in /confirmation and there is nothing.
      // setTimeout(() => {
      //   transferToCustomerPortal({ answers });
      // }, 2000);
      return (
        <div className="av-card">
          Thank you for letting us know about your incident. You will now be redirected to the policy portal.
        </div>
      );
    }

    let enquiryText: string | undefined;
    const isEnquiry = submissionType === 'enquiry';
    if (isEnquiry) {
      enquiryText = saveClaimText;
    }

    const exitButtonId = 'return-to-dashboard-btn';
    const handleExitButton = () => transferToCustomerPortal({ answers });
    return (
      <Row>
        <Col xs={12}>
          <div className="av-card claim-confirmation-card" tabIndex={-1}>
            <BasicHeadingControl heading={heading} subheading={subHeading} />
            <div className="hp-list-card">
              {enquiryText && <div>{enquiryText}</div>}
              <div>
                {claimReferenceText}&nbsp;<strong>{claimReferenceNumber}</strong>
              </div>
              <div className="whats-next">
                <ul>
                  {whatsNextItems && <div></div>}
                  {whatsNextItems &&
                    whatsNextItems.map((item, index) => {
                      const { body, title } = item;
                      return (
                        <li key={index}>
                          <DetailsWidget heading={title} body={body} />
                        </li>
                      );
                    })}
                </ul>
              </div>
              <button
                id={exitButtonId}
                name={exitButtonId}
                onClick={handleExitButton}
                type="button"
                className="btn btn-dark hp-next-section animated"
              >
                Return to my dashboard
              </button>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ClaimEnquiryResultDispatchProps {
  transferToCustomerPortal: (
    payload: HpTransferToCustomerPortalPayload
  ) => (dispatch: HpDispatchFunction<HpTransferToCustomerPortalPayload>) => void;
}

const mapDispatchToProps = (dispatch: (payload: any) => any): ClaimEnquiryResultDispatchProps => {
  return {
    transferToCustomerPortal: (
      props: HpTransferToCustomerPortalPayload
    ): ((dispatch: HpDispatchFunction<HpTransferToCustomerPortalPayload>) => void) =>
      dispatch(transferToCustomerPortalAction({ ...props }))
  };
};

const mapStateToProps = (state: HpGlobalState): HpStateProps => {
  const { claimEnquiryResult, questionSet } = state;
  return { ...claimEnquiryResult, answers: questionSet.answers };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClaimEnquiryResultPage));
